module.exports = require("core-js/library/fn/array/from");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/array/from.js
// module id = 1363
// module chunks = 0